<template>
  <div class="home-container">
    <img
        src="../assets/logo.png"
        alt="Cinopedia"
        class="home-image"
    >
    <h1>CINOPEDIA.CLOUD</h1>
    <div class="background-container primary-box" itemscope itemtype="https://schema.org/NewsArticle">
      <img
          src="../assets/logo.png"
          alt="Cinopedia"
          style="display: none"
          itemprop="image"
      >
      <h2 itemprop="headline">{{getTranslation('it', 'welcome-title-search')}}</h2>
      <h4>{{getTranslation('it', "welcome-text-search")}} 
        <router-link to="/breeds" class="search-link" itemprop="url">
          {{getTranslation('it', "breed")}}
        </router-link>, 
        <router-link to="/motivational-classifications" class="search-link" itemprop="url">
          {{getTranslation('it', "motivational-classification")}}
        </router-link>
         o 
        <router-link to="/enci-groups" class="search-link" itemprop="url">
          {{getTranslation('it', "enci-group")}}
        </router-link>
      </h4>
      <div class="search-button-container" style="display: none">
        <v-btn to="/motivational-classifications" rounded class="primary-box-btn">
          {{getTranslation('it', "motivational-groups")}}
        </v-btn>
        <v-btn to="" rounded class="primary-box-btn">
          {{getTranslation('it', "breed-list")}} ENCI/FCI
        </v-btn>
        <v-btn to="/enci-groups" rounded class="primary-box-btn">
          {{getTranslation('it', "enci-groups")}}
        </v-btn>
      </div>
      <div class="search-container">
        <SearchAllAutocomplete
            class="search-autocomplete"
            :label="getTranslation('it', 'search-your-dog')"
        />
      </div>
      <p style="display: none" itemprop="author" itemtype="https://schema.org/Person">
        <span itemprop="name">Cinopedia.cloud</span>
      </p>
    </div>
    <div class="background-container primary-box" itemscope itemtype="https://schema.org/NewsArticle">
      <h2 itemprop="headline">{{getTranslation('it', "welcome-title-articles")}}</h2>
      <img
          src="/img/newsstand.svg"
          alt="Cinopedia"
          style="display: none"
          itemprop="image"
      >
      <p>{{getTranslation('it', "welcome-text-articles")}}</p>
      <v-btn to="/article-categories" rounded class="primary-box-btn" itemprop="url">
        {{getTranslation('it', "start-reading")}}
      </v-btn>
      <p style="display: none" itemprop="author" itemtype="https://schema.org/Person">
        <span itemprop="name">Cinopedia.cloud</span>
      </p>
    </div>
    <div class="background-container primary-box" itemscope itemtype="https://schema.org/NewsArticle">
      <h2 itemprop="headline">{{getTranslation('it', "welcome-title-lessons")}}</h2>
      <v-avatar image="/img/davide.jpg" size="150" class="avatar"></v-avatar>
      <img
          src="/img/davide.jpg"
          alt="Cinopedia"
          style="display: none"
          itemprop="image"
      >
      <p>{{getTranslation('it', "welcome-text-lessons")}}</p>
      <p>{{getTranslation('it', "welcome-text-lessons-2")}}</p>
      <p>{{getTranslation('it', "welcome-text-lessons-3")}}</p>
      <h3>{{getTranslation('it', "welcome-text-lessons-contact-us")}}</h3>
      <p>{{getTranslation('it', "welcome-text-lessons-contact-us-by-mail")}} <a href="mailto:cinopedia@fiveamtech.it">cinopedia@fiveamtech.it</a></p>
      <p>{{getTranslation('it', "welcome-text-lessons-contact-us-by-social")}}</p>

      <div class="social-links">
        <a href="https://www.instagram.com/cinopedia.cloud" target="_blank" itemprop="url">
          <img src="/img/instagram.svg" alt="Instagram">
        </a>
        <a href="https://www.tiktok.com/@cinopedia.cloud" target="_blank" itemprop="url">
          <img src="/img/tiktok.svg" alt="TikTok">
        </a>
        <a href="https://www.facebook.com/profile.php?id=61569617216385" target="_blank" itemprop="url">
          <img src="/img/facebook.svg" alt="TikTok">
        </a>
      </div>
      <p style="display: none" itemprop="author" itemtype="https://schema.org/Person">
        <span itemprop="name">Cinopedia.cloud</span>
      </p>
    </div>
    <div class="background-container primary-box" itemscope itemtype="https://schema.org/NewsArticle">
      <h2 itemprop="headline">{{getTranslation('it', "welcome-title-about")}}</h2>
      <img
          src="../assets/logo.png"
          alt="Cinopedia"
          style="display: none"
          itemprop="image"
      >
      <p style="display: none" itemprop="url">/</p>
      <p>{{getTranslation('it', "welcome-text")}}</p>
      <p>{{getTranslation('it', "welcome-text-contact-us")}} <a href="mailto:cinopedia@fiveamtech.it">cinopedia@fiveamtech.it</a></p>
      <p style="display: none" itemprop="author" itemtype="https://schema.org/Person">
        <span itemprop="name">Cinopedia.cloud</span>
      </p>
    </div>
    
  </div>
</template>

<script>
import SearchAllAutocomplete from "@/components/SearchAllAutocomplete.vue";
import {getTranslation} from "@/services/stringTableService";
import {updateMetaInfo} from "@/middleware/metaUpdater";

export default {
  name: 'HomeHome',
  methods: {getTranslation},
  components: {SearchAllAutocomplete},
  props: {
  },
  created() {
    updateMetaInfo({})
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../style/_variables.scss';

.home-container {
  //background-color: rgba($primary-color,0.1);
  //-webkit-box-shadow: 0px 0px 5px 5px rgba($primary-color,0.64);
  //box-shadow: 0px 0px 5px 5px rgba($primary-color,0.64);
  background-color: $secondary-background-color;
  border-radius: 5px;
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  .avatar {
    margin-top: 10px;
    margin-bottom: 10px;
    box-shadow: 0px 0px 3px 3px rgba($tertiary-color,0.64);
  }
  .search-button-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    gap: 5px;
    .v-btn {
      width: 220px;
    }
  }
  .search-link {
    font-weight: 700;
    cursor: pointer;
    text-decoration: underline;
    text-transform: uppercase;
  }
  p {
    margin-top: 5px;
    margin-bottom: 20px;
    font-family: $font-base;
    font-weight: 500;
    a {
      font-weight: 700;
      color: $tertiary-color;
      cursor: pointer;
      text-decoration: underline;
    }
  }
  .secondary-color {
    color: $secondary-color;
  }
  h1, h2, h3, h4, h5, h6 {
    font-family: $header-font;
  }
  h1 {
    color:transparent;
    background-clip: text;
    background-image: $primary-gradient;
    font-family: $header-font;
    font-optical-sizing: auto;
    font-weight: 700;
    font-style: normal;
    font-size: 3rem;
  }
  h2 {
    margin-top: 20px;
    font-family: $header-font;
  }
  h3 {
    margin-top: 20px;
    margin-bottom: 10px;
    font-family: $header-font;
  }
  .home-image {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 45%;
  }
  .background-container {
    width: 100%;
    margin-top: 20px;
    padding: 20px;
    .search-container {      
      width: 100%;
      margin-top: 20px;
    }
    
  }

}

@media (max-width: 700px) {
  .home-container {
    width: 100%;
    min-height: $main-min-height;
    margin: 0;
    border-radius: 5px;
  }
}
</style>
